import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

const AiDataSource = lazy(() => import('testDev/AiDataSource'));
const AiDataSourceDesignsIndex = lazy(
  () => import('testDev/AiDataSourceDesignsIndex'),
);
const AiDataSourceVideoIndex = lazy(
  () => import('testDev/AiDataSourceVideoIndex'),
);
const CloudPlatformLanding = lazy(
  () => import('@/pages/integration/aiCloudPlatform/CloudPlatformLanding'),
);

const AiDataSourceInstance = lazy(() => import('testDev/AiDataSourceInstance'));
const ServiceProviderLanding = lazy(
  () => import('@/pages/integration/aiServiceProvider/ServiceProviderLanding'),
);
const AzureInstance = lazy(
  () => import('@/pages/integration/azureInstance/AzureInstance'),
);
const BitBucketTableLandingSlider = lazy(
  () => import('@/pages/integration/BitBucket/BitBucketLandingPage'),
);
const FireflinkProvider = lazy(
  () => import('@/pages/integration/fireflink/FireflinkProvider'),
);
const GitHubTableLandingSlider = lazy(
  () => import('@/pages/integration/GitHub/GitHubLandingpage'),
);
const GitLabInstance = lazy(
  () => import('@/pages/integration/gitlabInstance/GitLabInstance'),
);
const IndividualProjectIntegrationLandingPage = lazy(
  () => import('@/pages/integration/IndividualProjectIntegrationLandingPage'),
);
const IntegrationLandingPage = lazy(
  () => import('@/pages/integration/IntegrationLandingPage'),
);
const JiraInstance = lazy(
  () => import('@/pages/integration/jiraInstance/JiraInstance'),
);
const SlackLandingPage = lazy(
  () => import('@/pages/integration/SlackIntegration/SlackLandingPage'),
);
const TableLandingSlider = lazy(
  () => import('@/pages/integration/TableLandingSlider'),
);
const ZohoLandingPage = lazy(
  () => import('@/pages/integration/zohoInstance/ZohoLandingPage'),
);
const ServiceNowInstance = lazy(
  () => import('@/pages/integration/serviceNowInstance/ServiceNowInstance'),
);

const MicroSoftTeams = lazy(
  () => import('@/pages/integration/MicroSoftTeams/MicroSoftTeamsLandingPage'),
);

const ClickUpInstance = lazy(
  () => import('@/pages/integration/clickup/ClickUpLandingPage'),
);

const AzureDevOpsInstance = lazy(
  () => import('@/pages/integration/azureDevOps/AzureDevOpsLandingPage'),
);
const MantisBtInstance = lazy(
  () => import('@/pages/integration/mantisBt/MantisBtLandingPage'),
);

export const IntegrationRoutes: RouteObject[] = [
  {
    path: '/integration/plugin',
    element: <IntegrationLandingPage />,
    children: [
      {
        path: ':cloudPlatform',
        element: <TableLandingSlider />,
      },
      {
        path: 'jira',
        element: <JiraInstance />,
      },
      {
        path: 'Gitlab',
        element: <GitLabInstance />,
      },
      {
        path: 'github',
        element: <GitHubTableLandingSlider />,
      },
      {
        path: 'Slack',
        element: <SlackLandingPage />,
      },
      {
        path: 'microsoft-teams',
        element: <MicroSoftTeams />,
      },
      {
        path: 'bitbucket',
        element: <BitBucketTableLandingSlider />,
      },
      {
        path: 'Azure',
        element: <AzureInstance />,
      },
      {
        path: 'fireflink-ai',
        element: <FireflinkProvider />,
      },
      {
        path: 'groq',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'open-ai',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'anthropic',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'google-gemini',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'azure-ai',
        element: <CloudPlatformLanding />,
      },
      {
        path: 'zoho-management',
        element: <ZohoLandingPage />,
      },
      {
        path: 'ServiceNow',
        element: <ServiceNowInstance />,
      },
      {
        path: 'ClickUp',
        element: <ClickUpInstance />,
      },
      {
        path: 'AzureDevOps',
        element: <AzureDevOpsInstance />,
      },
      {
        path: 'cursor',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'mantisbt',
        element: <MantisBtInstance />,
      },
    ],
  },
  {
    path: 'integration/:projectName',
    element: <IndividualProjectIntegrationLandingPage />,
    children: [
      {
        path: 'ai-data-source/files',
        element: <AiDataSource />,
      },
      {
        path: 'ai-data-source/instances',
        element: <AiDataSourceInstance />,
      },
      {
        path: 'ai-data-source/designs',
        element: <AiDataSourceDesignsIndex />,
      },
      {
        path: 'ai-data-source/videos',
        element: <AiDataSourceVideoIndex />,
      },
      {
        path: 'fireflink-ai',
        element: <FireflinkProvider />,
      },
      {
        path: 'groq',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'open-ai',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'anthropic',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'google-gemini',
        element: <ServiceProviderLanding />,
      },
      {
        path: 'azure-ai',
        element: <CloudPlatformLanding />,
      },
    ],
  },
];
